import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=351ac56d&scoped=true&"
import script from "./Faq.vue?vue&type=script&lang=ts&"
export * from "./Faq.vue?vue&type=script&lang=ts&"
import style0 from "./Faq.vue?vue&type=style&index=0&id=351ac56d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351ac56d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsArrowrightArrowRight24px: require('/var/www/packages/theme/components/icons/arrowright/ArrowRight24px.vue').default,AtomsAccordion: require('/var/www/packages/theme/components/atoms/Accordion.vue').default})
